// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"497":"9958393d","584":"48ec5b2a","787":"7da95b79"}[chunkId] + ".chunk.js";
};